// src/layouts/LandlordLayout.jsx
import React, { useState } from "react";
import LandlordSidebar from "../components/LandlordSidebar";
import LandlordNavbar from "../components/LandlordNavbar";
import { Menu, Building2 } from "lucide-react";

export default function LandlordLayout({ children }) {
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Sidebar */}
      <LandlordSidebar
        open={open}
        setOpen={setOpen}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      {/* Main content */}
      <div
        className={`flex-1 flex flex-col transition-all duration-300 ${
          open ? "lg:ml-72" : "lg:ml-0"
        }`}
      >
        {/* Topbar */}
        <div className="fixed top-0 left-0 right-0 z-10 flex items-center justify-between p-4 border-b bg-white shadow-sm lg:static">
          {/* Left button → mobile sidebar */}
          <button
            onClick={() => setMobileOpen(true)}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg text-gray-700 hover:bg-gray-100 transition"
          >
            <Building2 className="h-6 w-6" />
          </button>

          {/* Center (Desktop navbar) */}
          <div className="hidden lg:block flex-1">
            <LandlordNavbar />
          </div>

          {/* Right button → mobile nav toggle */}
          <button
            onClick={() => setNavOpen((prev) => !prev)}
            className="lg:hidden flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-700 border hover:bg-gray-100 transition"
          >
            <Menu className="h-5 w-5" />
            Menu
          </button>
        </div>

        {/* ✅ Mobile Navbar */}
        <LandlordNavbar
          mobile
          open={navOpen}
          onClose={() => setNavOpen(false)}
        />

        {/* Content */}
        <div className="flex-1 pt-16 p-4 sm:p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
}
